(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/drag-handler.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/drag-handler.js');

'use strict';

const {
  DragState,
  MouseEvents,
  TouchEvents,
  supportsTouch
} = svs.components.tbUi.carousel.utils;
const createDragHandler = function (el) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    onStart,
    onMove,
    onEnd,
    onRelease,
    selector
  } = options;
  let status = DragState.IDLE;
  let touch = supportsTouch();
  let enabled = true;
  const mouse = {
    x: 0,
    y: 0
  };
  const trackHandlers = [];
  let onStartCallback = onStart;
  let onMoveCallback = onMove;
  let onEndCallback = onEnd;
  let onReleaseCallback = onRelease;
  const DeviceEvent = touch ? TouchEvents : MouseEvents;
  const getLocationFromEvent = e => ({
    x: touch ? e.changedTouches[0].clientX : e.pageX,
    y: touch ? e.changedTouches[0].clientY : e.pageY
  });
  const handleMove = e => {
    var _onMoveCallback;

    const p = getLocationFromEvent(e);
    const dist = {
      x: p.x - mouse.x,
      y: p.y - mouse.y
    };
    (_onMoveCallback = onMoveCallback) === null || _onMoveCallback === void 0 || _onMoveCallback(dist);
  };
  const handleEnd = e => {
    var _onEndCallback;
    if (enabled && e.type === MouseEvents.START) {
      e.preventDefault();
    }
    const p = getLocationFromEvent(e);
    const dist = {
      x: p.x - mouse.x,
      y: p.y - mouse.y
    };
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    status = DragState.END;
    requestAnimationFrame(() => status = DragState.IDLE);
    (_onEndCallback = onEndCallback) === null || _onEndCallback === void 0 || _onEndCallback(dist);
  };
  const handleStart = e => {
    var _onStartCallback;
    if (!enabled || e.target.closest('button') || e.target.closest('a')) {
      return;
    }
    if (selector && !e.target.closest(selector)) {
      return;
    }
    if (e.type === MouseEvents.START) {
      e.preventDefault();
    }
    const p = getLocationFromEvent(e);
    mouse.x = p.x;
    mouse.y = p.y;
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    window.addEventListener(DeviceEvent.MOVE, handleMove, {
      passive: false
    });
    window.addEventListener(DeviceEvent.STOP, handleEnd, {
      passive: false
    });
    status = DragState.START;
    requestAnimationFrame(() => status = DragState.DRAGGING);
    (_onStartCallback = onStartCallback) === null || _onStartCallback === void 0 || _onStartCallback(mouse);
  };
  const release = () => {
    var _onReleaseCallback;
    window.removeEventListener(DeviceEvent.MOVE, handleMove);
    window.removeEventListener(DeviceEvent.STOP, handleEnd);
    (_onReleaseCallback = onReleaseCallback) === null || _onReleaseCallback === void 0 || _onReleaseCallback();
  };
  const registerCallbacks = _ref => {
    let {
      onStart,
      onMove,
      onEnd,
      onRelease
    } = _ref;
    onStartCallback = onStart || onStartCallback;
    onMoveCallback = onMove || onMoveCallback;
    onEndCallback = onEnd || onEndCallback;
    onReleaseCallback = onRelease || onReleaseCallback;
  };
  const enable = () => {
    enabled = true;
  };
  const disable = () => enabled = false;
  const handleResize = () => {
    const t = supportsTouch();
    if (touch !== t) {
      touch = t;
    }
  };
  window.addEventListener('resize', handleResize);
  if (el && el instanceof Element) {
    trackHandlers.push(DeviceEvent.START);
    el.addEventListener(DeviceEvent.START, handleStart, {
      passive: false
    });
  }
  const unset = () => {
    window.removeEventListener('resize', handleResize);
    release();
    return () => {
      while (trackHandlers.length) {
        el === null || el === void 0 || el.removeEventListener(trackHandlers.pop(), handleStart);
      }
    };
  };
  return {
    enable,
    disable,
    release,
    registerCallbacks,
    status,
    unset
  };
};
setGlobal('svs.components.tbUi.carousel.createDragHandler', createDragHandler);

 })(window);